
    /**
    * 下架活动
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13290 {}
  /**
 * YResult :YResult
 */
export class IResid13290 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  export default (activityNo: any,  data?: IReqid13290): AxiosPromise<IResid13290> => request({
        method: 'POST',
        url: '/admin/activity/offShelfActivity/'+activityNo,
        data: data
      })